var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58335 1.83301H17.4167C17.6598 1.83301 17.893 1.92958 18.0649 2.10149C18.2368 2.2734 18.3334 2.50656 18.3334 2.74967V20.2974C18.3335 20.3794 18.3116 20.4599 18.27 20.5305C18.2284 20.6011 18.1687 20.6593 18.097 20.699C18.0253 20.7387 17.9442 20.7584 17.8623 20.7562C17.7804 20.7539 17.7006 20.7297 17.6312 20.6861L11 16.5272L4.36885 20.6852C4.29952 20.7287 4.21979 20.7529 4.13795 20.7552C4.0561 20.7575 3.97513 20.7379 3.90346 20.6983C3.83178 20.6587 3.77202 20.6007 3.73038 20.5302C3.68874 20.4597 3.66675 20.3793 3.66669 20.2974V2.74967C3.66669 2.50656 3.76326 2.2734 3.93517 2.10149C4.10708 1.92958 4.34024 1.83301 4.58335 1.83301Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.66669,
    y1: 1.83301,
    x2: 18.3936,
    y2: 2.06262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED456C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A362"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFill);
export default __webpack_public_path__ + "static/media/bookmark-fill.85e1b226.svg";
export { ForwardRef as ReactComponent };